import { Link, Outlet, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
  Image,
} from '@chakra-ui/react';

import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';
import { useGetFormTemplateByIdQuery } from '../../services';

export const FormsLayout = () => {
  const { formTemplateId } = useParams();

  const { data } = useGetFormTemplateByIdQuery(Number(formTemplateId), {
    skip: !formTemplateId,
  });

  return (
    <Box mx="8" h="full" display="flex" flexDirection="column">
      <Breadcrumb separator={<ChevronRightIcon />}>
        <BreadcrumbItem>
          <HStack fontSize="xs" color="custom_blue.1">
            <Image src="/sidebar/forms.svg" alt="roles icon" boxSize="4" />
            <Box>Form Builder</Box>
          </HStack>
        </BreadcrumbItem>

        <BreadcrumbItem
          isCurrentPage={location.pathname.endsWith('form-builder')}
        >
          <BreadcrumbLink
            as={Link}
            to={`/form-builder`}
            fontSize="xs"
            color="custom_blue.1"
            textTransform="capitalize"
          >
            Templates List
          </BreadcrumbLink>
        </BreadcrumbItem>

        {location.pathname.endsWith('new-form') && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('new-form')}
          >
            <BreadcrumbLink
              as={Link}
              to={`/form-builder/new-form`}
              fontSize="xs"
              color="custom_blue.1"
              textTransform="capitalize"
            >
              Create New Form
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}

        {formTemplateId && (
          <BreadcrumbItem isCurrentPage={Boolean(formTemplateId)}>
            <BreadcrumbLink
              as={Link}
              to={`/form-builder/${formTemplateId}`}
              fontSize="xs"
              color="custom_blue.1"
              textTransform="capitalize"
            >
              {data?.data.name}
            </BreadcrumbLink>
          </BreadcrumbItem>
        )}
      </Breadcrumb>

      <Outlet />
    </Box>
  );
};
